export default function formatTextQuantity(value) {
   const text = value === 1 ? 'unidad' : 'unidades';
   return `${value} ${text}`;
}
